import {
  FETCH_ANALYTICS_OVERVIEW,
  FETCH_ANALYTICS_OVERVIEW_SUCCESS,
  FETCH_ANALYTICS_OVERVIEW_FAILURE,
  FETCH_ANALYTICS_ENGAGEMENT,
  FETCH_ANALYTICS_ENGAGEMENT_SUCCESS,
  FETCH_ANALYTICS_ENGAGEMENT_FAILURE,
  FETCH_ANALYTICS_GENRES,
  FETCH_ANALYTICS_GENRES_SUCCESS,
  FETCH_ANALYTICS_GENRES_FAILURE,
  FETCH_ANALYTICS_LEADERBOARDS,
  FETCH_ANALYTICS_LEADERBOARDS_SUCCESS,
  FETCH_ANALYTICS_LEADERBOARDS_FAILURE,
  FETCH_ANALYTICS_BOOKS,
  FETCH_ANALYTICS_BOOKS_SUCCESS,
  FETCH_ANALYTICS_BOOKS_FAILURE,
  FETCH_ANALYTICS_USERS,
  FETCH_ANALYTICS_USERS_SUCCESS,
  FETCH_ANALYTICS_USERS_FAILURE,
  FETCH_ANALYTICS_SESSIONS,
  FETCH_ANALYTICS_SESSIONS_SUCCESS,
  FETCH_ANALYTICS_SESSIONS_FAILURE,
  EXPORT_ANALYTICS_CSV,
  EXPORT_ANALYTICS_CSV_SUCCESS,
  EXPORT_ANALYTICS_CSV_FAILURE,
} from "../ActionTypes";

const request = (type) => (payload = {}) => ({ type, payload });
const result = (type) => (payload) => ({ type, payload });

export const fetchAnalyticsOverview = request(FETCH_ANALYTICS_OVERVIEW);
export const fetchAnalyticsOverviewSuccess = result(FETCH_ANALYTICS_OVERVIEW_SUCCESS);
export const fetchAnalyticsOverviewFailure = result(FETCH_ANALYTICS_OVERVIEW_FAILURE);
export const fetchAnalyticsEngagement = request(FETCH_ANALYTICS_ENGAGEMENT);
export const fetchAnalyticsEngagementSuccess = result(FETCH_ANALYTICS_ENGAGEMENT_SUCCESS);
export const fetchAnalyticsEngagementFailure = result(FETCH_ANALYTICS_ENGAGEMENT_FAILURE);
export const fetchAnalyticsGenres = request(FETCH_ANALYTICS_GENRES);
export const fetchAnalyticsGenresSuccess = result(FETCH_ANALYTICS_GENRES_SUCCESS);
export const fetchAnalyticsGenresFailure = result(FETCH_ANALYTICS_GENRES_FAILURE);
export const fetchAnalyticsLeaderboards = request(FETCH_ANALYTICS_LEADERBOARDS);
export const fetchAnalyticsLeaderboardsSuccess = result(FETCH_ANALYTICS_LEADERBOARDS_SUCCESS);
export const fetchAnalyticsLeaderboardsFailure = result(FETCH_ANALYTICS_LEADERBOARDS_FAILURE);
export const fetchAnalyticsBooks = request(FETCH_ANALYTICS_BOOKS);
export const fetchAnalyticsBooksSuccess = result(FETCH_ANALYTICS_BOOKS_SUCCESS);
export const fetchAnalyticsBooksFailure = result(FETCH_ANALYTICS_BOOKS_FAILURE);
export const fetchAnalyticsUsers = request(FETCH_ANALYTICS_USERS);
export const fetchAnalyticsUsersSuccess = result(FETCH_ANALYTICS_USERS_SUCCESS);
export const fetchAnalyticsUsersFailure = result(FETCH_ANALYTICS_USERS_FAILURE);
export const fetchAnalyticsSessions = request(FETCH_ANALYTICS_SESSIONS);
export const fetchAnalyticsSessionsSuccess = result(FETCH_ANALYTICS_SESSIONS_SUCCESS);
export const fetchAnalyticsSessionsFailure = result(FETCH_ANALYTICS_SESSIONS_FAILURE);
export const exportAnalyticsCsv = request(EXPORT_ANALYTICS_CSV);
export const exportAnalyticsCsvSuccess = result(EXPORT_ANALYTICS_CSV_SUCCESS);
export const exportAnalyticsCsvFailure = result(EXPORT_ANALYTICS_CSV_FAILURE);
